import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, DesignphotoService } from "../../../services/index";
import * as commonActions from "../../../store/actions/common.actions";
import { AddEditDesignStock } from "./addEditdesignStock";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./designStock.html",
})
export class DesignStock implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    design_no: "",
    type: "Fresh",
  };
  typeList = ["Fresh", "Damage"];
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "design_no",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  stockList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private modalService: BsModalService,
    public toasterService: ToasterService,
    private designService: DesignphotoService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        cellClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
      },
      {
        name: "Design No",
        prop: "design_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Color",
        prop: "code",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "F36",
        prop: "F36",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "F38",
        prop: "F38",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "F40",
        prop: "F40",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "F42",
        prop: "F42",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "F44",
        prop: "F44",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "F46",
        prop: "F46",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "FTOT",
        prop: "fqty",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "H36",
        prop: "H36",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "H38",
        prop: "H38",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "H40",
        prop: "H40",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "H42",
        prop: "H42",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "H44",
        prop: "H44",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "H46",
        prop: "H46",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "HTOT",
        prop: "hqty",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "Tot Pcs",
        prop: "totqty",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#des").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getStockList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.design_no = "";
    this.filter.type = "Fresh";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getStockList();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  bsModalRef: BsModalRef;
  addEditUser(mode: string, row: any): void {
    let that = this;
    setTimeout(function () {
      that.filterPanel.close();
    }, 10);

    if (mode == "Add") {
      row = {
        des_id: "",
        design_id: "",
        design_no: "",
        code: "",
        type: "",
        mfg_date: new Date(),
        act_mfg_date: new Date(),
        f36: 0,
        f38: 0,
        f40: 0,
        f42: 0,
        f44: 0,
        f46: 0,
        h36: 0,
        h38: 0,
        h40: 0,
        h42: 0,
        h44: 0,
        h46: 0,
        fqty: 0,
        hqty: 0,
        totqty: 0,
        mode: mode,
      };
    }

    this.bsModalRef = this.modalService.show(AddEditDesignStock, {
      keyboard: false,
      ignoreBackdropClick: true,
      class: "modal-lg",
    });
    this.bsModalRef.content.title = mode + this.title;
    this.bsModalRef.content.mode = mode;
    this.bsModalRef.content.stkdata = Object.assign({}, row);
    this.bsModalRef.content.stock = this.stockList;
    (this.bsModalRef.content.tabID = this.tabID),
      (this.bsModalRef.content.tabTitle = this.title),
      this.bsModalRef.content.partyUpdateEvent.subscribe(($e) => {
        that.getStockList();
        if (this.title == "DesignStockComponent")
          this.store.dispatch(new commonActions.LoadAllParty());
        else this.store.dispatch(new commonActions.LoadAllCompany());
      });
  }
  getStockList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      type: this.filter.type,
      design_no: this.filter.design_no,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.designService
      .getDesignStockEntry(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.stockList = res.data;
        for (let i = 0; i < res.data.length; i++) {
          that.stockList[i].f36 = res.data[i].F36;
          that.stockList[i].f38 = res.data[i].F38;
          that.stockList[i].f40 = res.data[i].F40;
          that.stockList[i].f42 = res.data[i].F42;
          that.stockList[i].f44 = res.data[i].F44;
          that.stockList[i].f46 = res.data[i].F46;
          that.stockList[i].h36 = res.data[i].H36;
          that.stockList[i].h38 = res.data[i].H38;
          that.stockList[i].h40 = res.data[i].H40;
          that.stockList[i].h42 = res.data[i].H42;
          that.stockList[i].h44 = res.data[i].H44;
          that.stockList[i].h46 = res.data[i].H46;
        }
      });
  }

  /* deleteUser(row: any): void {
        let that = this; 
        swal({
            title: 'Are you sure to delete this User Details?',
            text: 'You will not be able to recover this ' + ' ' + row['username'] + '',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        }).then(function () {
            that.isLoadMask = that.designService
                .deleteUser(row)
                .then(function (res: any) {
                    that.loadingIndicator = false;
                    that.getStockList();
                    let errtype = "success", errmsg = res.message;
                    if(!res.success){
                        errtype = "error";
                    }

                    that.toasterService.pop({
                        bodyOutputType: 1,
                        type: errtype,
                        title: errtype.toUpperCase(),
                        body: errmsg
                    });
                });

        }, function (dismiss) {
        })
    }*/
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/DesignStock/designStock.ts